
class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input) return;

    this.input.form?.addEventListener(
      'reset',
      this.onFormReset.bind(this)
    );

    this.input.addEventListener('input', () => {
      this.onChange();
    });
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;

    this.resetButton.classList.toggle(
      'hidden',
      this.input.value.length === 0
    );
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector(
      '[aria-selected="true"] a'
    );
  }

  onFormReset(event) {
    event.preventDefault();

    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm);
}
